export const ROLE_UNCONFIRMED = 0;
export const ROLE_ADMIN = 1;
export const ROLE_USER = 2;
export const ROLE_RESEARCHER = 3;
export const ROLE_DEVELOPER = 4;

export const ROLE_LABELS = {
  [ROLE_UNCONFIRMED]: 'Не подтверждён',
  [ROLE_ADMIN]: 'Администратор',
  [ROLE_RESEARCHER]: 'Исследователь',
  [ROLE_USER]: 'Пользователь',
  [ROLE_DEVELOPER]: 'Разработчик',
};

export const ROLE_OPTIONS = [
  { id: ROLE_UNCONFIRMED, label: ROLE_LABELS[ROLE_UNCONFIRMED] },
  { id: ROLE_ADMIN, label: ROLE_LABELS[ROLE_ADMIN] },
  { id: ROLE_RESEARCHER, label: ROLE_LABELS[ROLE_RESEARCHER] },
  { id: ROLE_USER, label: ROLE_LABELS[ROLE_USER] },
  { id: ROLE_DEVELOPER, label: ROLE_LABELS[ROLE_DEVELOPER] },
];

export const MODULE_PERMISSIONS = {
  standard: 'calc.standard',
  interval: 'calc.interval',
  lq: 'calc.lq',
  adaptive_rt: 'calc.adaptive_rt',
};

export function permissionForModule(moduleId) {
  return MODULE_PERMISSIONS[String(moduleId || '')] || null;
}
